/* eslint-disable no-unused-vars */
import React from "react";
import { Tabs } from "antd";
import PrinterSettings from "./PrinterSettings";
import FeatureFlag from "./FeatureFlag";
import Security from "./Security";
const onChange = (key) => {
  // console.log(key);
};

const items = [
  // {
  //   key: "1",
  //   label: "General",
  //   children: <div className="content-box">Content of Tab Pane 1</div>,
  // },
  {
    key: "2",
    label: "Printers",
    children: (
      <div className="content-box">
        <PrinterSettings />
      </div>
    ),
  },
  // {
  //   key: "3",
  //   label: "Feature Flags",
  //   children: (
  //     <div className="content-items">
  //       <FeatureFlag />
  //     </div>
  //   ),
  // },
  // {
  //   key: "4",
  //   label: "Security",
  //   children: <Security />,
  // },
];

const App = () => (
  <div style={{ width: "100%" }} className="settings-tabs">
    <Tabs
      defaultActiveKey="1"
      items={items}
      onChange={onChange}
      tabBarStyle={{
        backgroundColor: "white",
        padding: "3px 20px 3px 20px",
        borderRadius: 5,
        width: "100%",
      }}
    />
  </div>
);

export default App;
